/**
 * @desc 重试中转执行
 */
const URL = "/rantion-bus";
import http, { updateResponse } from "@/http";
export function request(params: API.bus.exchange.reExecute.Params, options?: any) {
  return updateResponse(
    http(URL + `/exchange/reExecute`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
